/* eslint-disable */
import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase";

const functions = getFunctions(app, "europe-west2");

export async function sendBroadcast(payload) {
  const safePayload = {
    ...(payload || {}),
    category: payload?.category || "school_update",
    parentCategory: payload?.parentCategory || "school_update",
    source: "broadcast",
    pinned: Boolean(payload?.pinned),
  };

  const callable = httpsCallable(functions, "sendBroadcast");
  const result = await callable(safePayload);
  return result?.data || null;
}
